import React from 'react';
import { useMemo } from 'react';

import { RelayEnvironmentProvider } from 'react-relay';

import { createEnvironment } from './environment';
import { Domain } from 'src/clients/Network/http/fetch';

export default function RelayEnvironment({ children }: { children: React.ReactNode }) {
  // Create a new environment instance when the API env changes to reset the cache

  const environment = useMemo(() => {
    return createEnvironment(Domain.RHCreditCard);
  }, []);

  return <RelayEnvironmentProvider environment={environment}>{children}</RelayEnvironmentProvider>;
}
